import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Database, Loader2 } from "lucide-react";
import { api, formatError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AcceptInvite() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [invite, setInvite] = useState(null);
  const [error, setError] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get(`/invite/${token}`).then((r) => setInvite(r.data)).catch((e) => setError(formatError(e)));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return setError("Passwords don't match");
    setSaving(true);
    setError("");
    try {
      const { data } = await api.post(`/invite/${token}`, { password: pw });
      setUser(data);
      navigate("/", { replace: true });
    } catch (err) {
      setError(formatError(err));
      setSaving(false);
    }
  };

  const google = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(window.location.origin + "/")}`;
  };

  return (
    <div className="min-app-shell flex items-center justify-center p-6 grid-bg">
      <div className="w-full max-w-sm border rounded-lg bg-card p-8 space-y-6 fade-up" data-testid="accept-invite-page">
        <div className="flex items-center gap-2">
          <div className="h-8 w-8 rounded-md bg-primary flex items-center justify-center"><Database size={16} /></div>
          <span className="font-display text-lg font-bold">AccessBridge</span>
        </div>
        {!invite && !error && <Loader2 className="animate-spin text-primary" />}
        {!invite && error && <p className="text-red-400 text-sm" data-testid="invite-error">{error}</p>}
        {invite && (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <h1 className="text-2xl font-bold tracking-tight">Welcome, {invite.name}</h1>
              <p className="text-sm text-muted-foreground mt-1" data-testid="invite-email">Set a password for {invite.email}</p>
            </div>
            <div className="space-y-1.5"><Label htmlFor="pw">Password</Label>
              <Input id="pw" type="password" minLength={6} required value={pw} onChange={(e) => setPw(e.target.value)} data-testid="invite-password-input" /></div>
            <div className="space-y-1.5"><Label htmlFor="pw2">Confirm password</Label>
              <Input id="pw2" type="password" minLength={6} required value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="invite-confirm-input" /></div>
            {error && <p className="text-red-400 text-sm" data-testid="invite-error">{error}</p>}
            <Button type="submit" disabled={saving} className="w-full hover:bg-blue-600 hover:text-white" data-testid="invite-accept-button">
              {saving && <Loader2 size={14} className="animate-spin" />} Set password & sign in
            </Button>
            <Button type="button" variant="outline" onClick={google} className="w-full" data-testid="invite-google-button">Or continue with Google</Button>
          </form>
        )}
      </div>
    </div>
  );
}
